import { Component, Input } from '@angular/core';
import { AnimationOptions } from 'ngx-lottie';

import { AutoUnsubscribe } from '@app/shared/decorators/auto-unsubscribe.decorator';
@AutoUnsubscribe()
@Component({
  selector: 'create-account-placeholder-component',
  templateUrl: './create-account-placeholder.component.html',
})
export class CreateAccountPlaceholderComponent {
  @Input() username;
  @Input() formName;
  @Input() show_title = false;
  @Input() setHeight = false;
  animation: AnimationOptions = {
    path: '/assets/lottie/animation-4.json',
  };
}
